export const QuestionType = {

  EITHER_OR: 1,
  eitherOr: 1,

  MULTIPLE_CHOICE: 2,
  multipleChoice: 2,

  MULTIPLE_RESPONSE: 3,
  multipleResponse: 3,

  SHORT_ANSWER: 4,
  shortAnswer: 4,

  ESSAY: 5,
  essay: 5,

  NUMERIC: 6,
  numeric: 6,

  MATCH: 9,
  match: 9,

  ORDER: 10,
  order: 10,

  HOTSPOT: 11,
  hotspot: 11,

  FILE_RESPONSE: 12,
  fileResponse: 12,

  FILL_IN_THE_BLANK_TEXT: 14,
  fillInTheBlankText: 14,

  FILL_IN_THE_BLANK_GAP: 15,

  EQUATION: 16,
  equationEntry: 16,

  SELECT_FROM_THE_LIST: 17,
  selectFromTheList: 17,

  SOWISO: 18,
  sowiso: 18,

  SECTION: 19,
  section: 19,

  EXTENDED_MATCH: 20,
  extendedMatch: 20,

  DRAG_AND_DROP: 21,
  dragAndDrop: 21,

  ASSESSMENT_PAGE: 22,
  assessmentPage: 22,

  PROGRAMMING: 23,
  vpl: 23,

  FINANCIAL_STATEMENTS: 24,
  financialStatement: 24,

  EXTENDED_MULTIPLE_CHOICE: 25,
  extendedMC: 25,
  extendedMultipleChoice: 25,

  COMPREHENSIVE_INTEGRATED_PUZZLE: 26,
  ciPuzzle: 26,
}
